/** @jsx jsx */
import { ReactNode } from 'react';
import { Text } from '@zapier/design-system';
import { jsx } from '@emotion/core';
import {
  PaymentSourceType,
  PayPalPaymentSource,
} from '@zapier/payment/src/types';

import PaymentMethodImage from '@zapier/payment/src/components/PaymentMethodImage';

type ChildrenProps = {
  /** Paypal Payment source details */
  paypal: PayPalPaymentSource['details'];
};

type Props = {
  children?: (a: ChildrenProps) => ReactNode;

  /** Show compact version of info */
  isCompact?: boolean;
} & ChildrenProps;

const detailsCss = {
  marginLeft: 15,
};

const wrapperCss = {
  alignItems: 'center',
  display: 'flex',
};

const renderDefaultInfo = ({ paypal }: ChildrenProps) => (
  <Text fontWeight={700} type="smallPrint1">
    {paypal?.email}
  </Text>
);

const renderCompactInfo = ({ paypal }: ChildrenProps) => (
  <Text color="gray60" type="smallPrint1">
    {paypal?.email}
  </Text>
);

const PaypalInfo = ({
  isCompact = false,
  children = isCompact ? renderCompactInfo : renderDefaultInfo,
  ...props
}: Props) => (
  <div css={wrapperCss}>
    <PaymentMethodImage
      imageType={PaymentSourceType.paypal}
      isSmall={isCompact}
    />
    <div css={detailsCss}>{children(props)}</div>
  </div>
);

export default PaypalInfo;
